import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {LoaderService} from "./_services/loader.service";
import {AuthService} from "./_services/auth.service";
import {StorageService} from "./_services/storage.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'payout-portal-fe';
  isLoading: boolean;
  private subscriber$: Subscription;

  constructor(
    private loaderService: LoaderService,
    private readonly authService: AuthService,
    private readonly storageService: StorageService
  ) {
  }

  ngOnInit(): void {
    this.subscriber$ = this.loaderService.spinnerLoadingObserver.subscribe((val) => {
      this.isLoading = val as boolean;
    });

    // Auto-start notification stream if user is logged in after page refresh
    // if (this.storageService.isLoggedIn()) {
    //   console.log('🔄 User is logged in, starting notification stream on app initialization');
      // this.authService.startNotificationStream();
    // }
  }

  ngOnDestroy(): void {
    this.subscriber$.unsubscribe()
  }
}
